import { getDestination } from './destinations';

// Package prices on the site are base prices; government taxes are added on top.
export const GST_RATE = 0.05; // GST on tour packages
export const TCS_RATE = 0.02; // TCS on overseas tour packages

export const isInternational = (pkgOrDest) => {
  // Indian temple yatras are domestic even when their "destination" is a temple town we have no page for
  if (pkgOrDest && typeof pkgOrDest === 'object' && pkgOrDest._pilgrimage) return false;
  const id = typeof pkgOrDest === 'string' ? pkgOrDest : pkgOrDest?.destination;
  const d = getDestination(id);
  return d ? d.region !== 'India' : true;
};

/** Short label shown next to prices, e.g. "+ 5% GST & 2% TCS". */
export const taxLabel = (intl) => (intl ? '+ 5% GST & 2% TCS' : '+ 5% GST');

/** GST on the base amount; TCS (overseas only) on base + GST. */
export const withTaxes = (base, intl) => {
  const gst = Math.round(base * GST_RATE);
  const tcs = intl ? Math.round((base + gst) * TCS_RATE) : 0;
  return { base, gst, tcs, total: base + gst + tcs };
};
